import {
	useHyperSpotBalances,
	useUserAbstraction,
} from "#/hooks/use-hyperliquid-account";
import { toNumber } from "#/lib/formatters";

export function useUnifiedBalance() {
	const abstraction = useUserAbstraction();
	const spot = useHyperSpotBalances();

	const usdcBalance = spot.balances.find((b) => b.coin === "USDC");
	const spotUsdc = toNumber(usdcBalance?.total);
	const spotUsdcHold = toNumber(usdcBalance?.hold);

	return {
		isUnified: abstraction.isUnified,
		isDexAbstraction: abstraction.isDexAbstraction,
		spotUsdc,
		spotUsdcHold,
		isError: abstraction.isError || spot.isError,
		error: abstraction.error ?? spot.error,
		refetch: () => {
			abstraction.refetch();
			spot.refetch();
		},
	};
}
